<style>
.success-c {
  background-color: greenyellow !important;
}

.error-c {
  background-color: red;
}
</style>
<style scoped="scoped" lang="scss">
/deep/._configuration .el-dialog .el-dialog__body {
  max-height: calc(86vh - 112px);
  padding: 0 0 40px 68px;
}

.detail-target {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  // 左侧
  .left {
    display: flex;
    align-items: center;

    .icon {
      display: inline-block;
      //width: 5px;
      //height: 16px;
      //background: #419FFF;
    }

    .txt {
      display: inline-block;
      font-weight: 400;
      font-size: 16px;
      color: #303133;
      margin-left: 20px;
    }
  }

  // 右侧
  .right {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
}
</style>
<template>
  <div class="production-monthly">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"> </yi_curd_table>
    <!-- 表单 -->
    <div class="form" style="margin-left: 20px;">
      <div ref="search1">
        <el-form style="height: 28px;margin-bottom: 100px" :model="equipmentProduction.searchForm" :inline="true" size="mini">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="equipmentProduction.searchForm.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="equipmentProduction.searchForm.planNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="equipmentProduction.searchForm.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('erpxuqiulaiyuandanhao')">
            <el-input v-model="equipmentProduction.searchForm.erpRequireSourceNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="equipmentProduction.searchForm.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <el-input v-model="equipmentProduction.searchForm.mouldName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="equipmentProduction.searchForm.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('gongdanzhuangtai')">
            <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_PLAN_REPORT_WO_STATUS'" :ids.sync="equipmentProduction.searchForm.status" :showOptionIds="equipmentProduction.searchForm.statusOptionShow"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :type="'organization'" :ids.sync="equipmentProduction.orgId" :idsPath.sync="equipmentProduction.searchForm.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('baobiaoshijian')">
            <yi_time_input :maxTime="31 * 24 * 3600 * 1000" type="datetimerange" :start.sync="equipmentProduction.searchForm.reportDateStart" :end.sync="equipmentProduction.searchForm.reportDateEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleCurrentChange(1)" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button type="default" @click="resetEquipmentProduction" plain style="margin-left: 10px;">
              {{ $t("chongzhi") }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
            <el-button size="mini" @click="adjustShow = !adjustShow" type="primary" v-if="utils.checkPower('web_production_management_work_order_execution_adjust')">
              {{ $t("piliangtiaozheng") }}
            </el-button>
            <el-button size="mini" @click="yt.showEditDialog('danjitiaozheng', null, '80%')" type="primary" v-if="utils.checkPower('web_production_management_work_order_execution_single_adjust_button')">
              {{ $t("danjitiaozheng") }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="detail-target">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">
          <el-tag type="warning" size="small">{{ $t("jihuashu") }}</el-tag>
          <el-tag type="success" size="small" style="margin-left: 12px">{{ $t("yibaogongliangpinshu") }}</el-tag>
        </span>
      </div>
      <div class="right">
        <el-tooltip content="下载" placement="bottom" effect="light">
          <el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :loading="downLoading" @click="planReport()"> </el-button>
        </el-tooltip>
        <el-tooltip content="配置列" placement="bottom" effect="light">
          <el-button size="mini" type="default" @click="showShowTableColumn('equipmentProduction')">
            <i class="yicon yicon-config_column"></i>
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <!-- 图表和表单 -->
    <div class="echart-table">
      <div class="table" style="margin: 20px;overflow: auto;">
        <el-table stripe max-height="600" :data="equipmentProduction.tableData" border size="mini" v-loading="searchLoading" :row-style="{ height: 42 + 'px' }" :cell-style="cellStyle" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" :show-overflow-tooltip="true" row-key="id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" @header-dragend="headerDragend">
          <el-table-column v-for="(item, index) in productTableColumn" :key="index" :prop="item.prop" :fixed="item.fixed" :label="$t(item.label)" :sortable="item.sortable" :width="item.width" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="!['woNo', 'planNo', 'erpNo', 'status', 'orgName', 'equipmentName', 'erpRequireSourceNo', 'mouldCode', 'mouldName','materialName','materialSpec','materialColor','materialIngredient',  'materialCode', 'materialNo', 'planQuantity', 'productionQuantity', 'finishGoodQuantity', 'priority', 'planStartTime', 'actualStartTime', 'preFinishTime', 'remark'].includes(item.prop)" style="color: #419FFF">{{ scope.row[item.prop] }}</span>
              <span v-else-if="item.prop === 'status'">
                <el-tag v-if="scope.row.status === 1" size="mini">{{ $t("xinjian") }}</el-tag>
                <el-tag v-if="scope.row.status === 2" size="mini">{{ $t("fafang") }}</el-tag>
                <el-tag v-if="scope.row.status === 3" size="mini" type="success">{{ $t("shengchanzhong") }}</el-tag>
                <el-tag v-if="scope.row.status === 4" size="mini" type="danger">{{ $t("zanting") }}</el-tag>
                <el-tag v-if="scope.row.status === 5" size="mini" type="success">{{ $t("shougongxuwangong") }}</el-tag>
                <el-tag v-if="scope.row.status === 6" size="mini" type="success">{{ $t("wangong") }}</el-tag>
                <el-tag v-if="scope.row.status === 7" size="mini" type="info">{{ $t("guanbi") }}</el-tag>
                <el-tag v-if="scope.row.status === 8" size="mini" type="warning">{{ $t("yidiaobo") }}</el-tag>
              </span>
              <span v-else style="color: #606266">{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right; margin-top:8px">
          <el-pagination class="fy" layout="total,prev, pager, next,sizes" :current-page="equipmentProduction.currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handleCurrentChange" @next-click="handleCurrentChange" :total="parseInt(equipmentProduction.total)" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" background> </el-pagination>
        </div>
      </div>
    </div>
    <!-- 自定义显示项 -->
    <el-dialog v-if="showTableColumn.dialog" class="_configuration" :title="$t(showTableColumn.title)" :visible.sync="showTableColumn.dialog" width="720px">
      <template v-if="showTableColumn.type === 'equipmentProduction'">
        <el-transfer
            ref="transfer"
            :titles="[$t('yincanglie'), $t('xianshilie')]"
            v-model="showTableColumn.equipmentProduction.show"
            :format="{
            noChecked: '${total}',
            hasChecked: '${total}'
          }"
            :data="equipmentProduction.tableColumn"
            @change="showColumnsChange"
        >
          <div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;" @dragstart="drag($event, option)">
            <div>{{ $t(option.label) }}</div>
          </div>
        </el-transfer>
      </template>
    </el-dialog>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'danjitiaozheng'">
        <div class="dialog-scroller">
          <singleAdjust ref="singleAdjust" @list-change="singleAdjustListChange"></singleAdjust>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" :disabled="singleAdjustList == null || singleAdjustList.length === 0" @click="batchSetPriority" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 批量调整 -->
    <batchAdjust :show.sync="adjustShow" />
  </div>
</template>
<script type="text/javascript">
import batchAdjust from "@@/pages/web/report/plan_report/batch_adjust";
import singleAdjust from "@@/pages/web/report/plan_report/single_adjust";
import Sortable from "sortablejs";

const date = new Date();
const all = date.setDate(30);
const year = date.getFullYear();
const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
const end = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 23, 59, 59).getTime();
export default {
  name: "web_report_plan_report_list",
  components: {
    batchAdjust,
    singleAdjust,
  },
  data() {
    return {
      productTableColumn: [],
      draggingKey: "",
      adjustShow: false,
      singleAdjustList: [],
      searchLoading: false,
      downLoading: false,
      conditions: {},
      fildIds: "",
      styleStatus: [],
      currentStart: "",
      currentEnd: "",
      chartValueData: [],
      chartHeight2: 120,
      timer: null,
      chart: null,
      options2: null,
      status: [],
      statusColors: {
        "0": "#67C23A",
        "3": "#F56C6C",
        "1": "#E6A23C",
        "-1": "#909399",
      },
      show: true,
      activeName: "second",
      // <!-- 状态  1新建、2发放、3生产中、4暂停、5首工序完工、6完工、7关闭、8已调拨  -->
      //默认选择：发放、生产中、暂停。
      equipmentProduction: {
        orgId: this.store.state.organizations[0].id,
        searchForm: {
          reportDateStart: begin,
          reportDateEnd: end,
          status: ["2", "3", "4"],
          statusOptionShow: ["2", "3", "4", "5", "6"],
        },
        tableData: [],
        tableColumn: [
          {
            label: this.$t("shengchangongdanhao"),
            prop: "woNo",
            width: "150",
            key: 0,
            // fixed: true
          },
          {
            label: this.$t("jihuadanhao"),
            prop: "planNo",
            width: "150",
            key: 1,
            // fixed: true
          },
          {
            label: this.$t("ERPgongdanhao"),
            prop: "erpNo",
            width: "150",
            key: 2,
            // fixed: true
          },
          {
            label: this.$t("erpxuqiulaiyuandanhao"),
            prop: "erpRequireSourceNo",
            width: "150",
            key: 3,
            // fixed: true
          },
          {
            label: this.$t("gongdanzhuangtai"),
            prop: "status",
            width: "150",
            key: 4,
            // fixed: true,
          },
          {
            label: this.$t("guishuchejian"),
            prop: "orgName",
            width: "150",
            key: 5,
            // fixed: true,
          },
          {
            label: this.$t("shebeimingcheng"),
            prop: "equipmentName",
            width: "150",
            key: 6,
            // fixed: true,
          },
          {
            label: this.$t("mujubianhao"),
            prop: "mouldCode",
            width: "150",
            key: 7,
            // fixed: true,
          },
          {
            label: this.$t("mujumingcheng"),
            prop: "mouldName",
            width: "150",
            key: 8,

            // fixed: true,
          },
          {
            label: this.$t("chanpinbianma"),
            prop: "materialCode",
            width: "150",
            key: 9,
            // fixed: true,
          },
          {
            label: this.$t("chanpinmingcheng"),
            prop: "materialName",
            width: "150",
            key: 10,
            // fixed: true,
          },
          {
            label: this.$t("liaohao"),
            prop: "materialNo",
            width: "150",
            key: 11,
          },
          {
            label: this.$t("guige"),
            prop: "materialSpec",
            width: "150",
            key: 12,
          },
          {
            label: this.$t("yanse"),
            prop: "materialColor",
            width: "150",
            key: 13,
          },
          {
            label: this.$t("caizhi"),
            prop: "materialIngredient",
            width: "150",
            key: 14,
          },
          {
            label: this.$t("dingdanzhongliang(KG)"),
            prop: "weight",
            width: "150",
            key: 15,
            // fixed: true,
          },
          {
            label: this.$t("danzhong(G)"),
            prop: "singleWeight",
            width: "150",
            key: 16,
            // fixed: true,
          },
          {
            label: this.$t("jihuashuliang"),
            prop: "planQuantity",
            width: "150",
            key: 17,
            // fixed: true,
          },
          {
            label: this.$t("shengchanshuliang"),
            prop: "productionQuantity",
            width: "150",
            key: 18,
            // fixed: true,
          },
          {
            label: this.$t("yibaogongliangpinshu"),
            prop: "finishGoodQuantity",
            width: "150",
            key: 19,
            // fixed: true,
          },
          {
            label: this.$t("gongdanshunxu"),
            prop: "priority",
            width: "150",
            key: 20,
          },
          {
            label: this.$t("jihuakaishishijian"),
            prop: "planStartTime",
            width: "150",
            key: 21,
          },
          {
            label: this.$t("shijikaishishijian"),
            prop: "actualStartTime",
            width: "150",
            key: 22,
          },
          {
            label: this.$t("wangongyuceshijian"),
            prop: "preFinishTime",
            width: "150",
            key: 23,
          },
          {
            label: this.$t("beizhu"),
            prop: "remark",
            width: "150",
            key: 24,
          },
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      newColumn:[],
      showTableColumn: {
        dialog: false,
        title: "peizhixianshilie",
        type: "equipmentProduction",
        equipmentProduction: {
          show: [],
          initShow: [],
        },
      },
      currentTime: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0),
    };
  },
  created() {
    setTimeout(() => {
      this.getCurrentMonthLast();
      // 按照班次升序 +  产品编码升序排序。
      this.yt.conditions = {
        orderBy: "shiftName,materialName asc",
      };
      this.getEquipmentBasicReport();
      this.utils.event_hub.$on("PLAN_REPORT_REFRESH", () => {
        this.getEquipmentBasicReport();
      });
    }, 300);
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  destroyed() {
    clearTimeout(this.timer);
    // 取消对bus事件的监听
    this.utils.event_hub.$off("PLAN_REPORT_REFRESH");
  },
  methods: {
    // 设置列
    setTableColumn() {
      const name = "colwidth_producee_report_second";
      let colwidths = null;
      if (localStorage.getItem(name)) {
        try {
          colwidths = JSON.parse(localStorage.getItem(name));
          if (colwidths && this.newColumn) {
            const aNum = this.newColumn[0].num;
            const bNum = colwidths.find(item => item.num).num
            if(aNum === bNum){
              localStorage.getItem(name)
            }else {
              localStorage.removeItem(name)
            }

          }
          console.log('colwidths11111',colwidths)
        } catch (e) {
          localStorage.removeItem(name)
        }
      }
      if (Array.isArray(colwidths) && colwidths.length > 0) {
        return colwidths.filter(item => {
          return item.show !== "no"
        });
      }
      let tableColumn = [];
      if (colwidths === null) {
        tableColumn = JSON.parse(JSON.stringify(this.equipmentProduction.tableColumn))
        console.log('colwidths22222',tableColumn)
      } else {
        for (let i = 0; i < this.equipmentProduction.tableColumn.length; i++) {
          if (this.showTableColumn.equipmentProduction.show.includes(this.equipmentProduction.tableColumn[i]["key"])) {
            tableColumn.push(this.equipmentProduction.tableColumn[i]);
          }
        }
        console.log('colwidths33333',tableColumn)
      }
      if (tableColumn.length > 0 && colwidths !== null) {
        for (const i in tableColumn) {
          if (colwidths[this.$t(tableColumn[i]["label"])] !== undefined) {
            this.$set(tableColumn[i], "width", colwidths[this.$t(tableColumn[i]["label"])]);
          }
        }
      }
      return tableColumn;
    },
    // 显示/隐藏列表
    showColumnsChange() {
      const currentShow = this.showTableColumn.equipmentProduction.show
      const name = 'colwidth_producee_report_second'
      let colwidths = localStorage.getItem(name)
      if (colwidths) {
        try {
          colwidths = JSON.parse(colwidths)
        } catch (e) {
          localStorage.removeItem(name)
          return
        }
        for (let i = 0; i < colwidths.length; i++) {
          if (!currentShow.includes(colwidths[i]['key'])) {
            colwidths[i]['show'] = 'no'
          } else {
            colwidths[i]['show'] = 'yes'
          }
        }
        localStorage.setItem(name, JSON.stringify(colwidths))
      } else {
        const columns = JSON.parse(JSON.stringify(this.equipmentProduction.tableColumn))
        for (let i = 0; i < columns.length; i++) {
          if (!currentShow.includes(columns[i]['key'])) {
            columns[i]['show'] = 'no'
          }
        }
        localStorage.setItem(name, JSON.stringify(columns))
      }

      this.productTableColumn = this.setTableColumn()
      console.log('setTableColumn',this.productTableColumn)
    },
    // 列宽拖动
    headerDragend(newWidth, oldWidth, column, event) {
      const name = "colwidth_producee_report_second"
      let colwidths = null;
      if (localStorage.getItem(name)) {
        try {
          colwidths = JSON.parse(localStorage.getItem(name));
        } catch (e) {
          localStorage.removeItem(name)
        }
      }
      if (colwidths) {
        for (let i = 0; i < colwidths.length; i++) {
          if (colwidths[i]['label'] === column.label) {
            colwidths[i]['width'] = newWidth
          }
        }
        localStorage.setItem(name, JSON.stringify(colwidths));
      } else {
        localStorage.setItem(name, JSON.stringify(this.equipmentProduction.tableColumn));
      }
    },
    // 列排序
    initColumnsTransfer() {
      const transfer = this.$refs.transfer.$el;
      const leftPanel = transfer.getElementsByClassName("el-transfer-panel")[0].getElementsByClassName("el-transfer-panel__body")[0];
      const rightPanel = transfer.getElementsByClassName("el-transfer-panel")[1].getElementsByClassName("el-transfer-panel__body")[0];
      const rightEl = rightPanel.getElementsByClassName("el-transfer-panel__list")[0];
      Sortable.create(rightEl, {
        animation: 100,
        onEnd: (evt) => {
          // 查询隐藏列
          let hiddenColumn = []
          const name = "colwidth_producee_report_second"
          if (localStorage.getItem(name)) {
            try {
              const colwidths = JSON.parse(localStorage.getItem(name));
              hiddenColumn = colwidths.filter(item => {
                return item.show === 'no'
              })
            } catch (e) {
              localStorage.removeItem(name)
            }
          }
          const { oldIndex, newIndex } = evt;
          const temp = this.productTableColumn[oldIndex];
          if (!temp || temp === "undefined") {
            return;
          } // 解决右边最后一项从右边拖左边，有undefined的问题
          //这里和网上的有点不一样,网上搜到的结果排序是,当前拖拽的元素和拖拽位置的元素互换位置,但是实际上在使用el-transfer有两个问题
          //1.右侧排序value的数组顺序来源于后台穿的数组顺序,实际如果不设置target-order="unshift"的话,展示会按照左侧的数据列顺序展示,导致拖拽排序时顺序乱七八糟
          //2.实际拖拽排序看到的效果是当前拖拽元素拖拽到其他地方,其他地方的元素会下移,而不是调换顺序
          // 去除空字符串
          for (let i = 0; i < this.productTableColumn.length; i++) {
            if (this.productTableColumn[i] === "" || this.productTableColumn[i] === null || typeof this.productTableColumn[i] === "undefined") {
              this.productTableColumn.splice(i, 1);
              i = i - 1;
            }
          }
          const arr_temp = [].concat(this.productTableColumn); // 创建一个新的临时数组，用以操作后不变更原数组
          arr_temp.splice(newIndex, 0, arr_temp.splice(oldIndex, 1)[0]); // 在b位置插入从a位置截取的元素
          if (hiddenColumn.length > 0) {
            for (let i = 0; i < hiddenColumn.length; i++) {
              arr_temp.unshift(hiddenColumn[i])
            }
          }
          //保存
          localStorage.setItem("colwidth_producee_report_second", JSON.stringify(arr_temp))
          this.productTableColumn = this.setTableColumn()
        },
      });
      const leftEl = leftPanel.getElementsByClassName("el-transfer-panel__list")[0];
      Sortable.create(leftEl, {
        animation: 100,
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt;
          const temp = this.datas[oldIndex];
          this.$set(this.datas, oldIndex, this.datas[newIndex]);
          this.$set(this.datas, newIndex, temp);
        },
      });
      leftPanel.ondragover = (ev) => {
        ev.preventDefault();
      };
      leftPanel.ondrop = (ev) => {
        ev.preventDefault();
        const index = this.equipmentProduction.tableColumn.indexOf(this.draggingKey);
        if (index !== -1) {
          this.equipmentProduction.tableColumn.splice(index, 1);
        }
      };
      rightPanel.ondragover = (ev) => {
        ev.preventDefault();
      };
      rightPanel.ondrop = (ev) => {
        ev.preventDefault();
        if (this.equipmentProduction.tableColumn.indexOf(this.draggingKey) === -1) {
          this.equipmentProduction.tableColumn.push(this.draggingKey);
        }
      };
    },
    drag(ev, option) {
      this.draggingKey = option.key;
    },
    getCurrentMonthLast() {
      const date = new Date();
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      const day = new Date(year, month, 0);
      this.endTime = year + "-" + month + "-" + day.getDate();
    },
    //导出
    planReport() {
      this.downLoading = true;
      let params = {
        ...this.equipmentProduction.searchForm,
      };
      if (Array.isArray(params["status"]) && params["status"].length > 0) {
        params["status"] = params["status"].join(",");
      }
      if (Array.isArray(params["orgId"]) && params["orgId"].length > 0) {
        params["orgId"] = params["orgId"].join(",");
      }
      return this.http
          .get("/web/report/export/production_plan_wo_report?" + this.qs.stringify(params))
          .then((res) => {
            let fildId = res.data;
            return this.http
                .get("/web/report/work/get", {
                  params: {
                    id: fildId,
                  },
                })
                .then((response) => {
                  this.downLoading = false;
                  this.fildIds = response.data.fileId;
                  let status = response.data.status;
                  if (status == 1) {
                    this.getDownload();
                    this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
                    this.$message.success(this.$t(response.msg));
                  } else if (status == -1) {
                    this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
                    this.$message.success(this.$t(response.msg));
                  } else if (status == 0 || null) {
                    this.timer = setInterval(() => {
                      this.getDownload();
                    }, 1000);
                  }
                })
                .catch((err) => {
                  this.downLoading = false;
                });
          })
          .catch((error) => {
            this.$message.error(this.$t(error));
            this.downLoading = false;
          });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex > 2) {
        if (isNaN(column.property) && !isNaN(Date.parse(column.property))) {
          let customTime = column.property;
          customTime = customTime.replace("-", "/");
          customTime = new Date(Date.parse(customTime)).getTime();
          if (customTime >= this.currentTime) {
            return {
              backgroundColor: "#FDF6EB",
              color: "#FFFFFF",
            };
          } else {
            return {
              backgroundColor: "#F0F9EB",
              color: "#FFFFFF",
            };
          }
        }
      }
    },
    singleAdjustListChange(list) {
      this.singleAdjustList = list;
    },
    batchSetPriority() {
      let list = this.$refs.singleAdjust.yt.list;
      if (list == null || list.length === 0) {
        return;
      }
      this.yt.editObj.loading = true;
      let params = {};
      list.forEach((l) => {
        params[l.id] = l.priority;
      });

      this.http
          .post("/custom/qunlong/first/inspection/batchSetPriority", params)
          .then((res) => {
            this.yt.isShowEditDialog = false;
            this.yt.editObj.loading = false;
            this.$message.success(this.$t(res.msg));
          })
          .catch((e) => {
            this.yt.editObj.loading = false;
            this.utils.errorMessage(e);
          });
    },
    handleSizeChange(value) {
      this.equipmentProduction.pageSize = value;
      this.getEquipmentBasicReport();
    },
    handleCurrentChange(value) {
      this.equipmentProduction.currentPage = value;
      this.getEquipmentBasicReport();
    },
    getEquipmentBasicReport() {
      this.show = false;
      this.searchLoading = true;
      this.equipmentProduction.tableColumn = [
        {
          label: this.$t("shengchangongdanhao"),
          prop: "woNo",
          width: "150",
          key: 0,
          // fixed: true
        },
        {
          label: this.$t("jihuadanhao"),
          prop: "planNo",
          width: "150",
          key: 1,
          // fixed: true
        },
        {
          label: this.$t("ERPgongdanhao"),
          prop: "erpNo",
          width: "150",
          key: 2,
          // fixed: true
        },
        {
          label: this.$t("erpxuqiulaiyuandanhao"),
          prop: "erpRequireSourceNo",
          width: "150",
          key: 3,
          // fixed: true
        },
        {
          label: this.$t("gongdanzhuangtai"),
          prop: "status",
          width: "150",
          key: 4,
        },
        {
          label: this.$t("guishuchejian"),
          prop: "orgName",
          width: "150",
          key: 5,
        },
        {
          label: this.$t("shebeimingcheng"),
          prop: "equipmentName",
          width: "150",
          key: 6,
        },
        {
          label: this.$t("mujubianhao"),
          prop: "mouldCode",
          width: "150",
          key: 7,
        },
        {
          label: this.$t("mujumingcheng"),
          prop: "mouldName",
          width: "150",
          key: 8,
        },
        {
          label: this.$t("chanpinbianma"),
          prop: "materialCode",
          width: "150",
          key: 9,
        },
        {
          label: this.$t("chanpinmingcheng"),
          prop: "materialName",
          width: "150",
          key: 10,
        },
        {
          label: this.$t("liaohao"),
          prop: "materialNo",
          width: "150",
          key: 11,
        },
        {
          label: this.$t("guige"),
          prop: "materialSpec",
          width: "150",
          key: 12,
        },
        {
          label: this.$t("yanse"),
          prop: "materialColor",
          width: "150",
          key: 13,
        },
        {
          label: this.$t("caizhi"),
          prop: "materialIngredient",
          width: "150",
          key: 14,
        },
        {
          label: this.$t("dingdanzhongliang(KG)"),
          prop: "weight",
          width: "150",
          key: 15,
          // fixed: true,
        },
        {
          label: this.$t("danzhong(G)"),
          prop: "singleWeight",
          width: "150",
          key: 16,
          // fixed: true,
        },
        {
          label: this.$t("jihuashuliang"),
          prop: "planQuantity",
          width: "150",
          key: 17,
        },
        {
          label: this.$t("shengchanshuliang"),
          prop: "productionQuantity",
          width: "150",
          key: 18,
        },
        {
          label: this.$t("yibaogongliangpinshu"),
          prop: "finishGoodQuantity",
          width: "150",
          key: 19,
        },
        {
          label: this.$t("gongdanshunxu"),
          prop: "priority",
          width: "150",
          key: 20,
        },
        {
          label: this.$t("jihuakaishishijian"),
          prop: "planStartTime",
          width: "150",
          key: 21,
        },
        {
          label: this.$t("shijikaishishijian"),
          prop: "actualStartTime",
          width: "150",
          key: 22,
        },
        {
          label: this.$t("wangongyuceshijian"),
          prop: "preFinishTime",
          width: "150",
          key: 23,
        },

        {
          label: this.$t("beizhu"),
          prop: "remark",
          width: "150",
          key: 24,
        },
      ];
      for (let i = 0; i < this.equipmentProduction.tableColumn.length; i++) {
        this.showTableColumn.equipmentProduction.show.push(i)
      }
      // const maxDay = this.getMonthLength(this.equipmentProduction.searchForm['reportDateStr'])
      let params = {
        ...this.equipmentProduction.searchForm,
        pageSize: this.equipmentProduction.pageSize,
        pageNum: this.equipmentProduction.currentPage,
      };
      if (Array.isArray(params["status"]) && params["status"].length > 0) {
        params["status"] = params["status"].join(",");
      }
      if (Array.isArray(params["orgId"]) && params["orgId"].length > 0) {
        params["orgId"] = params["orgId"].join(",");
      }
      if (Array.isArray(params["equipmentId"]) && params["equipmentId"].length > 0) {
        params["equipmentId"] = params["equipmentId"].join(",");
      }
      if (Array.isArray(params["mouldId"]) && params["mouldId"].length > 0) {
        params["mouldId"] = params["mouldId"].join(",");
      }
      if (Array.isArray(params["materialId"]) && params["materialId"].length > 0) {
        params["materialId"] = params["materialId"].join(",");
      }
      return this.http
          .get("/web/report/page/production_plan_wo_report?" + this.qs.stringify(params))
          .then((res) => {
            this.equipmentProduction.tableData = res.data.rows;
            this.equipmentProduction.total = res.data.total;
            let data = res.data.rows;
            let dateMap = data.map((item, i) => {
              return item.dateMap != undefined && item.dateMap != null ? JSON.parse(item.dateMap) : "";
            });

            if (this.equipmentProduction.tableData.length > 0) {
              // 格式化
              for (let i = 0; i < this.equipmentProduction.tableData.length; i++) {
                //计划开始时间
                if (this.equipmentProduction.tableData[i]["planStartTime"] === undefined) {
                  this.equipmentProduction.tableData[i]["planStartTime"] = "";
                } else {
                  this.equipmentProduction.tableData[i]["planStartTime"] = this.dayjs.unix(this.equipmentProduction.tableData[i]["planStartTime"] / 1000).format("YYYY-MM-DD HH:mm:ss");
                }
                //实际开始时间
                if (this.equipmentProduction.tableData[i]["actualStartTime"] === undefined) {
                  this.equipmentProduction.tableData[i]["actualStartTime"] = "";
                } else {
                  this.equipmentProduction.tableData[i]["actualStartTime"] = this.dayjs.unix(this.equipmentProduction.tableData[i]["actualStartTime"] / 1000).format("YYYY-MM-DD HH:mm:ss");
                }
                //完工预测时间
                if (this.equipmentProduction.tableData[i]["preFinishTime"] === undefined) {
                  this.equipmentProduction.tableData[i]["preFinishTime"] = "";
                } else {
                  this.equipmentProduction.tableData[i]["preFinishTime"] = this.dayjs.unix(this.equipmentProduction.tableData[i]["preFinishTime"] / 1000).format("YYYY-MM-DD HH:mm:ss");
                }
                if (this.equipmentProduction.tableData[i]["children"] === undefined) {
                  this.equipmentProduction.tableData[i]["children"] = [];
                } else {
                  this.equipmentProduction.tableData[i]["children"] = JSON.parse(this.equipmentProduction.tableData[i]["children"]);
                  if (this.equipmentProduction.tableData[i]["children"].length > 0) {
                    for (let j = 0; j < this.equipmentProduction.tableData[i]["children"].length; j++) {
                      //计划开始时间
                      if (this.equipmentProduction.tableData[i]["children"][j]["planStartTime"] === undefined) {
                        this.equipmentProduction.tableData[i]["children"][j]["planStartTime"] = "";
                      } else {
                        this.equipmentProduction.tableData[i]["children"][j]["planStartTime"] = this.dayjs.unix(this.equipmentProduction.tableData[i]["children"][j]["planStartTime"] / 1000).format("YYYY-MM-DD HH:mm:ss");
                      }
                      //实际开始时间
                      if (this.equipmentProduction.tableData[i]["children"][j]["actualStartTime"] === undefined) {
                        this.equipmentProduction.tableData[i]["children"][j]["actualStartTime"] = "";
                      } else {
                        this.equipmentProduction.tableData[i]["children"][j]["actualStartTime"] = this.dayjs.unix(this.equipmentProduction.tableData[i]["children"][j]["actualStartTime"] / 1000).format("YYYY-MM-DD HH:mm:ss");
                      }
                      //完工预测时间
                      if (this.equipmentProduction.tableData[i]["children"][j]["preFinishTime"] === undefined) {
                        this.equipmentProduction.tableData[i]["children"][j]["preFinishTime"] = "";
                      } else {
                        this.equipmentProduction.tableData[i]["children"][j]["preFinishTime"] = this.dayjs.unix(this.equipmentProduction.tableData[i]["children"][j]["preFinishTime"]).format("YYYY-MM-DD HH:mm:ss");
                      }
                    }
                  }
                }
              }
              let reses = dateMap[0];
              this.styleStatus = dateMap[0];
              let column = [];
              let key = 24;
              for (let i in reses) {
                column.push({
                  key: key,
                  label: i,
                  prop: i,
                  num: parseInt(i.substr(4)),
                  width: "120",
                });
                this.showTableColumn.equipmentProduction.show.push(key);
                ++key;
              }
              this.newColumn = column
              console.log('reses111',column)
              this.showTableColumn.equipmentProduction.initShow = [...this.showTableColumn.equipmentProduction.show];
              // column.sort(this.sortData)
              for (let i = 0; i < column.length; i++) {
                this.equipmentProduction.tableColumn.push(column[i]);
              }
            }

            this.productTableColumn = this.setTableColumn()
            this.searchLoading = false;
            this.show = true;
          })
          .catch((error) => {
            this.utils.errorMessage(error);
            this.searchLoading = false;
          });
    },
    // 排序
    // sortData(a, b) {
    //   return a.num - b.num
    // },
    exportBasicProductionExcel() {
      let requestParam = {
        ...this.equipmentProduction.searchForm,
      };

      if (Array.isArray(requestParam["materialId"]) && requestParam["materialId"].length > 0) {
        requestParam["materialId"] = requestParam["materialId"].join(",");
      }
      if (Array.isArray(requestParam["orgId"]) && requestParam["orgId"].length > 0) {
        requestParam["orgId"] = requestParam["orgId"].join(",");
      }
      if (requestParam["reportDateStr"] !== undefined && requestParam["reportDateStr"] !== "") {
        requestParam["reportDateStr"] = requestParam["reportDateStr"].split("-").join("");
      }
      for (const i in requestParam) {
        if (requestParam[i] === "" || requestParam[i] === null || requestParam[i] === undefined) {
          delete requestParam[i];
        }
      }
      return this.http
          .get("/web/report/export/mes_basic_production_report_shift?" + this.qs.stringify(requestParam))
          .then((response) => {
            let fildId = response.data;
            // this.$message.success(this.$t(response.msg))
            return this.http
                .get("/web/report/work/get", {
                  params: {
                    id: fildId,
                  },
                })
                .then((response) => {
                  this.fildIds = response.data.fileId;
                  // console.log('response.msg1', response.data.status)
                  let status = response.data.status;
                  if (status == 1) {
                    this.getDownload();
                    this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
                    this.$message.success(this.$t(response.msg));
                  } else if (status == -1) {
                    this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
                    this.$message.success(this.$t(response.msg));
                  } else if (status == 0 || null) {
                    this.timer = setInterval(() => {
                      this.getDownload();
                    }, 1000);
                  }
                });
          })
          .catch((error) => {
            this.$message.error(this.$t(error));
          });
    },
    getDownload() {
      // console.log('this.fildIdthis.fildId', this.fildIds)
      return this.http.get("/web/customer/files/download?id=" + this.fildIds).then((res) => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    },
    //  重置产量月报
    resetEquipmentProduction() {
      this.equipmentProduction.searchForm = {
        status: ["2", "3", "4"],
        reportDateStart: begin,
        reportDateEnd: end,
      };
      this.showTableColumn.equipmentProduction.show = []

      this.equipmentProduction.orgId = null;
      this.$nextTick(() => {
        this.equipmentProduction.orgId = this.store.state.organizations[0].id;
        this.getEquipmentBasicReport();
        // const name = 'colwidth_producee_report_second'
        // localStorage.removeItem(name)
        // this.productTableColumn = this.setTableColumn()
      });
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        this.screenWidth = document.body.clientWidth;
        if (this.produceeReportChart != null) {
          this.produceeReportChart.resize();
        }
        if (this.reportChart != null) {
          this.reportChart.resize();
        }
        if (this.chart != null) {
          this.chart.resize();
        }
      }, 500);
    },
    // 显示选择项
    showShowTableColumn(type) {
      this.showTableColumn.type = type;
      this.showTableColumn.dialog = true;
      const currentShow = this.showTableColumn.equipmentProduction.show
      const afterShow = []
      let columnStorage = localStorage.getItem('colwidth_producee_report_second')
      if (columnStorage) {
        columnStorage = JSON.parse(columnStorage)
        const disabledShow = columnStorage.filter(item => {
          return item.show === 'no'
        }).map(item => {
          return item.key
        })
        for (let i = 0; i < currentShow.length; i++) {
          if (!disabledShow.includes(currentShow[i])) {
            afterShow.push(currentShow[i])
          }
        }
        console.log('disabledShow', disabledShow)
        console.log('afterShow', afterShow)
        this.equipmentProduction.tableColumn = columnStorage
        this.showTableColumn.equipmentProduction.show = afterShow
      }
      this.$nextTick(() => {
        this.initColumnsTransfer();
      });
    },
    // 取消选择项
    cancelShowTableColumn() {
      this.showTableColumn.show = [...this.showTableColumn.initShow];
      this.showTableColumn.dialog = false;
    },
    // 打开产品详情弹框
    showProductionDetail(row, date) {
      this.yt.showEditDialog("chanpinxiangqing", row, "w2");
    },
  },
};
</script>
